import { createFileRoute } from '@tanstack/react-router';
import MyTasks from '../../components/staff/MyTasks';
import StaffPortal from '../../components/portals/StaffPortal';

export const Route = createFileRoute('/staff/tasks')({
  component: StaffTasksRoute,
});

function StaffTasksRoute() {
  return (
    <StaffPortal>
      <MyTasks />
    </StaffPortal>
  );
}
